"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return View;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _bcryptjs = /*#__PURE__*/ _interop_require_default(require("bcryptjs"));
const _common = require("@nestjs/common");
const _ncError = require("~/helpers/ncError");
const _rowColorViewHelpers = require("~/helpers/rowColorViewHelpers");
const _Model = /*#__PURE__*/ _interop_require_default(require("~/models/Model"));
const _FormView = /*#__PURE__*/ _interop_require_default(require("~/models/FormView"));
const _GridView = /*#__PURE__*/ _interop_require_default(require("~/models/GridView"));
const _KanbanView = /*#__PURE__*/ _interop_require_default(require("~/models/KanbanView"));
const _GalleryView = /*#__PURE__*/ _interop_require_default(require("~/models/GalleryView"));
const _CalendarView = /*#__PURE__*/ _interop_require_default(require("~/models/CalendarView"));
const _GridViewColumn = /*#__PURE__*/ _interop_require_default(require("~/models/GridViewColumn"));
const _CalendarViewColumn = /*#__PURE__*/ _interop_require_default(require("~/models/CalendarViewColumn"));
const _CalendarRange = /*#__PURE__*/ _interop_require_default(require("~/models/CalendarRange"));
const _Sort = /*#__PURE__*/ _interop_require_default(require("~/models/Sort"));
const _Filter = /*#__PURE__*/ _interop_require_default(require("~/models/Filter"));
const _GalleryViewColumn = /*#__PURE__*/ _interop_require_default(require("~/models/GalleryViewColumn"));
const _FormViewColumn = /*#__PURE__*/ _interop_require_default(require("~/models/FormViewColumn"));
const _KanbanViewColumn = /*#__PURE__*/ _interop_require_default(require("~/models/KanbanViewColumn"));
const _Column = /*#__PURE__*/ _interop_require_default(require("~/models/Column"));
const _MapView = /*#__PURE__*/ _interop_require_default(require("~/models/MapView"));
const _MapViewColumn = /*#__PURE__*/ _interop_require_default(require("~/models/MapViewColumn"));
const _ListView = /*#__PURE__*/ _interop_require_default(require("~/models/ListView"));
const _ListViewColumn = /*#__PURE__*/ _interop_require_default(require("~/models/ListViewColumn"));
const _ListViewLevel = /*#__PURE__*/ _interop_require_default(require("~/models/ListViewLevel"));
const _extractProps = require("~/helpers/extractProps");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _globals = require("~/utils/globals");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _modelUtils = require("~/utils/modelUtils");
const _models = require("~/models");
const _commandPaletteHelpers = require("~/helpers/commandPaletteHelpers");
const _utils = require("~/utils");
const _scriptHelper = require("~/helpers/scriptHelper");
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const { v4: uuidv4 } = require('uuid');
const logger = new _common.Logger('View');
let View = class View {
    static async get(context, viewId, ncMeta = _Noco.default.ncMeta) {
        let view = viewId && await _NocoCache.default.get(context, `${_globals.CacheScope.VIEW}:${viewId}`, _globals.CacheGetType.TYPE_OBJECT);
        if (!view) {
            view = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.VIEWS, viewId);
            if (view) {
                view.meta = (0, _modelUtils.parseMetaProp)(view);
                await _NocoCache.default.set(context, `${_globals.CacheScope.VIEW}:${view.id}`, view);
            }
        }
        return view && new View(view);
    }
    static async getByTitleOrId(context, { fk_model_id, titleOrId }, ncMeta = _Noco.default.ncMeta) {
        const viewId = titleOrId && await _NocoCache.default.get(context, `${_globals.CacheScope.VIEW_ALIAS}:${fk_model_id}:${titleOrId}`, _globals.CacheGetType.TYPE_STRING);
        if (!viewId) {
            const view = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.VIEWS, {
                fk_model_id
            }, null, {
                _or: [
                    {
                        id: {
                            eq: titleOrId
                        }
                    },
                    {
                        title: {
                            eq: titleOrId
                        }
                    }
                ]
            });
            if (view) {
                await _NocoCache.default.set(context, `${_globals.CacheScope.VIEW}:${fk_model_id}:${view.id}`, view);
                view.meta = (0, _modelUtils.parseMetaProp)(view);
                // todo: cache - titleOrId can be viewId so we need a different scope here
                await _NocoCache.default.set(context, `${_globals.CacheScope.VIEW_ALIAS}:${fk_model_id}:${titleOrId}`, view.id);
            }
            return view && new View(view);
        }
        return viewId && this.get(context, (viewId == null ? void 0 : viewId.id) || viewId);
    }
    static async getFirstCollaborativeView(context, fk_model_id, ncMeta = _Noco.default.ncMeta) {
        let view = fk_model_id && await _NocoCache.default.get(context, `${_globals.CacheScope.VIEW}:${fk_model_id}:default`, _globals.CacheGetType.TYPE_OBJECT);
        if (!view) {
            view = (0, _nocodbsdk.getFirstNonPersonalView)(await this.list(context, fk_model_id, ncMeta), {
                includeViewType: _nocodbsdk.ViewTypes.GRID
            });
            if (view) {
                view.meta = (0, _modelUtils.parseMetaProp)(view);
                await _NocoCache.default.set(context, `${_globals.CacheScope.VIEW}:${fk_model_id}:default`, view);
            }
        }
        return view && new View(view);
    }
    static async list(context, modelId, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.VIEW, [
            modelId
        ]);
        let { list: viewsList } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !viewsList.length) {
            viewsList = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.VIEWS, {
                condition: {
                    fk_model_id: modelId
                },
                orderBy: {
                    order: 'asc'
                }
            });
            for (const view of viewsList){
                view.meta = (0, _modelUtils.parseMetaProp)(view);
            }
            await _NocoCache.default.setList(context, _globals.CacheScope.VIEW, [
                modelId
            ], viewsList);
        }
        viewsList.sort((a, b)=>(a.order != null ? a.order : Infinity) - (b.order != null ? b.order : Infinity));
        return viewsList == null ? void 0 : viewsList.map((v)=>new View(v));
    }
    // todo: refactor and move duplicate logic to service
    static async insert(context, { view, req }, ncMeta = _Noco.default.ncMeta) {
        let copyFromView;
        try {
            const insertObj = (0, _extractProps.extractProps)(view, [
                'id',
                'title',
                'description',
                'type',
                'fk_model_id',
                'base_id',
                'source_id',
                'meta'
            ]);
            // get order value
            insertObj.order = await ncMeta.metaGetNextOrder(_globals.MetaTable.VIEWS, {
                fk_model_id: view.fk_model_id
            });
            insertObj.show = true;
            if (!insertObj.meta) {
                insertObj.meta = {};
            }
            insertObj.meta = (0, _modelUtils.stringifyMetaProp)(insertObj);
            const model = await _Model.default.getByIdOrName(context, {
                id: view.fk_model_id
            }, ncMeta);
            // get base and base id if missing
            if (!view.source_id) {
                insertObj.source_id = model.source_id;
            }
            copyFromView = view.copy_from_id && await View.get(context, view.copy_from_id, ncMeta);
            await (copyFromView == null ? void 0 : copyFromView.getView(context));
            const { id: view_id } = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.VIEWS, insertObj);
            let columns = await (await _Model.default.getByIdOrName(context, {
                id: view.fk_model_id
            }, ncMeta)).getColumns(context, ncMeta);
            const levelIdMap = new Map();
            let defaultLevelId;
            // insert view metadata based on view type
            switch(view.type){
                case _nocodbsdk.ViewTypes.GRID:
                    await _GridView.default.insert(context, _extends({}, (copyFromView == null ? void 0 : copyFromView.view) || {}, view, {
                        fk_view_id: view_id
                    }), ncMeta);
                    break;
                case _nocodbsdk.ViewTypes.MAP:
                    await _MapView.default.insert(context, _extends({}, view, {
                        fk_view_id: view_id
                    }), ncMeta);
                    break;
                case _nocodbsdk.ViewTypes.LIST:
                    {
                        await _ListView.default.insert(context, _extends({}, (copyFromView == null ? void 0 : copyFromView.view) || {}, view, {
                            fk_view_id: view_id
                        }), ncMeta);
                        if (copyFromView == null ? void 0 : copyFromView.view) {
                            const sourceLevels = await _ListViewLevel.default.list(context, copyFromView.id, ncMeta);
                            for (const level of sourceLevels){
                                const newLevel = await _ListViewLevel.default.insert(context, _extends({}, (0, _extractProps.extractProps)(level, [
                                    'level',
                                    'fk_model_id',
                                    'fk_link_column_id',
                                    'enable_nested_records',
                                    'fk_self_link_column_id',
                                    'wrap_headers',
                                    'meta'
                                ]), {
                                    fk_view_id: view_id
                                }), ncMeta);
                                if (level.id && (newLevel == null ? void 0 : newLevel.id)) {
                                    levelIdMap.set(level.id, newLevel.id);
                                }
                                if (level.fk_model_id === view.fk_model_id && (newLevel == null ? void 0 : newLevel.id)) {
                                    defaultLevelId = newLevel.id;
                                }
                            }
                        } else {
                            const defaultLevel = await _ListViewLevel.default.insert(context, {
                                fk_view_id: view_id,
                                level: 0,
                                fk_model_id: view.fk_model_id
                            }, ncMeta);
                            defaultLevelId = defaultLevel == null ? void 0 : defaultLevel.id;
                        }
                        break;
                    }
                case _nocodbsdk.ViewTypes.GALLERY:
                    await _GalleryView.default.insert(context, _extends({}, (copyFromView == null ? void 0 : copyFromView.view) || {}, view, {
                        fk_view_id: view_id
                    }), ncMeta);
                    break;
                case _nocodbsdk.ViewTypes.FORM:
                    await _FormView.default.insert(context, _extends({
                        heading: view.title
                    }, (copyFromView == null ? void 0 : copyFromView.view) || {}, view, {
                        fk_view_id: view_id
                    }), ncMeta);
                    break;
                case _nocodbsdk.ViewTypes.KANBAN:
                    // set grouping field
                    view.fk_grp_col_id = view.fk_grp_col_id;
                    await _KanbanView.default.insert(context, _extends({}, (copyFromView == null ? void 0 : copyFromView.view) || {}, view, {
                        fk_view_id: view_id
                    }), ncMeta);
                    break;
                case _nocodbsdk.ViewTypes.CALENDAR:
                    {
                        const obj = (0, _extractProps.extractProps)(view, [
                            'calendar_range'
                        ]);
                        if (!obj.calendar_range) break;
                        const calendarRange = obj.calendar_range;
                        calendarRange.forEach((range)=>{
                            range.fk_view_id = view_id;
                        });
                        await _CalendarView.default.insert(context, _extends({}, (copyFromView == null ? void 0 : copyFromView.view) || {}, view, {
                            fk_view_id: view_id
                        }), ncMeta);
                        await _CalendarRange.default.bulkInsert(context, calendarRange, ncMeta);
                    }
            }
            if (copyFromView) {
                // generate parent audit id and add it to req object
                const eventId = await _Noco.default.ncAudit.genNanoid(_globals.MetaTable.AUDIT);
                req.ncParentAuditId = eventId;
                _Noco.default.appHooksService.emit(_nocodbsdk.AppEvents.VIEW_DUPLICATE_START, {
                    sourceView: copyFromView,
                    destView: view,
                    req,
                    context,
                    id: eventId
                });
                const sorts = await copyFromView.getSorts(context, ncMeta);
                const filters = await copyFromView.getFilters(context, ncMeta);
                columns = await copyFromView.getColumns(context, ncMeta);
                for (const sort of sorts){
                    const sortProps = (0, _extractProps.extractProps)(sort, [
                        'fk_column_id',
                        'fk_level_id',
                        'direction',
                        'base_id',
                        'source_id',
                        'order'
                    ]);
                    if (sortProps.fk_level_id) {
                        sortProps.fk_level_id = levelIdMap.get(sortProps.fk_level_id) || sortProps.fk_level_id;
                    }
                    await _Sort.default.insert(context, _extends({}, sortProps, {
                        fk_view_id: view_id,
                        id: null
                    }), ncMeta);
                    _Noco.default.appHooksService.emit(_nocodbsdk.AppEvents.SORT_CREATE, {
                        sort,
                        view: view,
                        column: await _Column.default.get(context, {
                            colId: sort.fk_column_id
                        }),
                        req,
                        context
                    });
                }
                for (const filter of filters.children){
                    const filterProps = (0, _extractProps.extractProps)(filter, [
                        'id',
                        'fk_level_id',
                        'fk_parent_column_id',
                        'fk_column_id',
                        'comparison_op',
                        'comparison_sub_op',
                        'value',
                        'fk_parent_id',
                        'is_group',
                        'logical_op',
                        'base_id',
                        'source_id',
                        'order'
                    ]);
                    if (filterProps.fk_level_id) {
                        filterProps.fk_level_id = levelIdMap.get(filterProps.fk_level_id) || filterProps.fk_level_id;
                    }
                    const createdFilter = await _Filter.default.insert(context, _extends({}, filterProps, {
                        fk_view_id: view_id,
                        id: null
                    }), ncMeta);
                    _Noco.default.appHooksService.emit(_nocodbsdk.AppEvents.FILTER_CREATE, {
                        filter: createdFilter,
                        column: await _Column.default.get(context, {
                            colId: filter.fk_column_id
                        }),
                        view: view,
                        req,
                        context
                    });
                }
            }
            {
                let order = 1;
                let galleryShowLimit = 0;
                let kanbanShowLimit = 0;
                let calendarRanges = null;
                if (view.type === _nocodbsdk.ViewTypes.CALENDAR) {
                    calendarRanges = await View.getRangeColumnsAsArray(context, view_id, ncMeta);
                }
                if (view.type === _nocodbsdk.ViewTypes.KANBAN && !copyFromView) {
                    // sort by display value & attachment first, then by singleLineText & Number
                    // so that later we can handle control `show` easily
                    columns.sort((a, b)=>{
                        const displayValueOrder = b.pv - a.pv;
                        const attachmentOrder = +(b.uidt === _nocodbsdk.UITypes.Attachment) - +(a.uidt === _nocodbsdk.UITypes.Attachment);
                        const singleLineTextOrder = +(b.uidt === _nocodbsdk.UITypes.SingleLineText) - +(a.uidt === _nocodbsdk.UITypes.SingleLineText);
                        const numberOrder = +(b.uidt === _nocodbsdk.UITypes.Number) - +(a.uidt === _nocodbsdk.UITypes.Number);
                        const defaultOrder = b.order - a.order;
                        return displayValueOrder || attachmentOrder || singleLineTextOrder || numberOrder || defaultOrder;
                    });
                }
                for (const vCol of columns){
                    let show = 'show' in vCol ? vCol.show : true;
                    const underline = false;
                    const bold = false;
                    const italic = false;
                    if (view.type === _nocodbsdk.ViewTypes.GALLERY) {
                        const galleryView = await _GalleryView.default.get(context, view_id, ncMeta);
                        if (vCol.id === galleryView.fk_cover_image_col_id || vCol.pv || galleryShowLimit < 3) {
                            show = true;
                            galleryShowLimit++;
                        } else {
                            show = false;
                        }
                    } else if (view.type === _nocodbsdk.ViewTypes.KANBAN && !copyFromView) {
                        const kanbanView = await _KanbanView.default.get(context, view_id, ncMeta);
                        if (vCol.id === (kanbanView == null ? void 0 : kanbanView.fk_grp_col_id)) {
                            // include grouping field if it exists
                            show = true;
                        } else if (vCol.id === kanbanView.fk_cover_image_col_id || vCol.pv) {
                            // Show cover image or primary key
                            show = true;
                            kanbanShowLimit++;
                        } else if (kanbanShowLimit < 3 && !(0, _nocodbsdk.isSystemColumn)(vCol)) {
                            // show at most 3 non-system columns
                            show = true;
                            kanbanShowLimit++;
                        } else {
                            // other columns will be hidden
                            show = false;
                        }
                    } else if (view.type === _nocodbsdk.ViewTypes.CALENDAR && !copyFromView) {
                        const calendarView = await _CalendarView.default.get(context, view_id, ncMeta);
                        if (calendarRanges && calendarRanges.includes(vCol.id)) {
                            show = true;
                        } else show = vCol.id === (calendarView == null ? void 0 : calendarView.fk_cover_image_col_id) || vCol.pv;
                    // Show all Fields in Ranges
                    } else if (view.type === _nocodbsdk.ViewTypes.MAP && !copyFromView) {
                        const mapView = await _MapView.default.get(context, view_id, ncMeta);
                        if (vCol.id === (mapView == null ? void 0 : mapView.fk_geo_data_col_id)) {
                            show = true;
                        }
                    }
                    // if columns is list of virtual columns then get the parent column
                    const col = vCol.fk_column_id ? await _Column.default.get(context, {
                        colId: vCol.fk_column_id
                    }, ncMeta) : vCol;
                    if ((0, _nocodbsdk.isSystemColumn)(col)) show = false;
                    await View.insertColumn(context, _extends({
                        order: order++
                    }, col, vCol, {
                        view_id,
                        fk_column_id: vCol.fk_column_id || vCol.id,
                        show,
                        underline,
                        bold,
                        italic,
                        id: null
                    }, defaultLevelId ? {
                        fk_level_id: defaultLevelId
                    } : {}), ncMeta);
                }
            }
            (0, _commandPaletteHelpers.cleanCommandPaletteCache)(context.workspace_id).catch(()=>{
                logger.error('Failed to clean command palette cache');
            });
            (0, _scriptHelper.cleanBaseSchemaCacheForBase)(context.base_id).catch(()=>{
                logger.error('Failed to clean base schema cache');
            });
            if (copyFromView) {
                _Noco.default.appHooksService.emit(_nocodbsdk.AppEvents.VIEW_DUPLICATE_COMPLETE, {
                    sourceView: copyFromView,
                    destView: view,
                    req,
                    context
                });
            }
            return View.get(context, view_id, ncMeta).then(async (v)=>{
                await _NocoCache.default.appendToList(context, _globals.CacheScope.VIEW, [
                    view.fk_model_id
                ], `${_globals.CacheScope.VIEW}:${view_id}`);
                return v;
            });
        } catch (e) {
            if (copyFromView) {
                _Noco.default.appHooksService.emit(_nocodbsdk.AppEvents.VIEW_DUPLICATE_FAIL, {
                    sourceView: copyFromView,
                    destView: view,
                    error: e,
                    req,
                    context
                });
                if (e instanceof _ncError.NcError || e instanceof _nocodbsdk.NcBaseError) throw e;
                logger.error('Failed to Duplicate View', e);
                _ncError.NcError.get(context).internalServerError('Failed to Duplicate View');
            }
            if (e instanceof _ncError.NcError || e instanceof _nocodbsdk.NcBaseError) throw e;
            logger.error('Failed to Duplicate View', e);
            _ncError.NcError.get(context).internalServerError('Failed to Create View');
        }
    }
    static async getRangeColumnsAsArray(context, viewId, ncMeta) {
        const calRange = await _CalendarRange.default.read(context, viewId, ncMeta);
        if (calRange) {
            const calIds = new Set();
            calRange.ranges.forEach((range)=>{
                calIds.add(range.fk_from_column_id);
            });
            return Array.from(calIds);
        }
        return [];
    }
    static async insertColumnToAllViews(context, param, ncMeta = _Noco.default.ncMeta) {
        const insertObj = {
            fk_column_id: param.fk_column_id,
            fk_model_id: param.fk_model_id,
            order: param.order,
            show: param.column_show.show
        };
        const views = await this.list(context, param.fk_model_id, ncMeta);
        const tableColumns = await _Column.default.list(context, {
            fk_model_id: param.fk_model_id
        }, ncMeta);
        // keep a map of column id to column object for easy access
        const colIdMap = new Map(tableColumns.map((c)=>[
                c.id,
                c
            ]));
        for (const view of views){
            var _colIdMap_get, _param_column_show, _param_column_order;
            const modifiedInsertObj = _extends({}, insertObj, {
                fk_view_id: view.id,
                source_id: view.source_id
            });
            if (((_colIdMap_get = colIdMap.get(param.fk_column_id)) == null ? void 0 : _colIdMap_get.uidt) === _nocodbsdk.UITypes.Order) {
                modifiedInsertObj.show = false;
            } else if (((_param_column_show = param.column_show) == null ? void 0 : _param_column_show.view_id) === view.id) {
                modifiedInsertObj.show = true;
            } else if (view.uuid) {
            // if view is shared, then keep the show state as it is
            } else if (view.type === _nocodbsdk.ViewTypes.GALLERY) {
                var _this;
                const visibleColumnsCount = (_this = await _GalleryViewColumn.default.list(context, view.id, ncMeta)) == null ? void 0 : _this.filter((c)=>c.show && !(0, _nocodbsdk.isSystemColumn)(colIdMap.get(c.fk_column_id))).length;
                modifiedInsertObj.show = visibleColumnsCount < 3;
            } else if (view.type === _nocodbsdk.ViewTypes.KANBAN) {
                var _this1;
                const visibleColumnsCount = (_this1 = await _KanbanViewColumn.default.list(context, view.id, ncMeta)) == null ? void 0 : _this1.filter((c)=>c.show && !(0, _nocodbsdk.isSystemColumn)(colIdMap.get(c.fk_column_id))).length;
                modifiedInsertObj.show = visibleColumnsCount < 3;
            } else if (view.type !== _nocodbsdk.ViewTypes.FORM) {
                modifiedInsertObj.show = true;
            }
            if (((_param_column_order = param.column_order) == null ? void 0 : _param_column_order.view_id) === view.id) {
                var _param_column_order1;
                modifiedInsertObj.order = (_param_column_order1 = param.column_order) == null ? void 0 : _param_column_order1.order;
            }
            switch(view.type){
                case _nocodbsdk.ViewTypes.GRID:
                    await _GridViewColumn.default.insert(context, modifiedInsertObj, ncMeta);
                    break;
                case _nocodbsdk.ViewTypes.GALLERY:
                    await _GalleryViewColumn.default.insert(context, modifiedInsertObj, ncMeta);
                    break;
                case _nocodbsdk.ViewTypes.MAP:
                    await _MapViewColumn.default.insert(context, _extends({}, insertObj, {
                        fk_view_id: view.id
                    }), ncMeta);
                    break;
                case _nocodbsdk.ViewTypes.LIST:
                    {
                        // Insert the column to the list view level matching the model id
                        const level = (await _ListViewLevel.default.list(context, view.id, ncMeta) || []).find((l)=>l.fk_model_id === param.fk_model_id);
                        const listOrder = (level == null ? void 0 : level.id) ? await _ListViewColumn.default.getNextOrderForLevel(context, view.id, level.id, ncMeta) : undefined;
                        await _ListViewColumn.default.insert(context, _extends({}, insertObj, {
                            fk_level_id: level == null ? void 0 : level.id,
                            fk_view_id: view.id,
                            order: listOrder
                        }), ncMeta);
                        break;
                    }
                case _nocodbsdk.ViewTypes.KANBAN:
                    await _KanbanViewColumn.default.insert(context, modifiedInsertObj, ncMeta);
                    break;
                case _nocodbsdk.ViewTypes.CALENDAR:
                    await _CalendarViewColumn.default.insert(context, _extends({}, insertObj, {
                        fk_view_id: view.id
                    }), ncMeta);
                    break;
                case _nocodbsdk.ViewTypes.FORM:
                    await _FormViewColumn.default.insert(context, modifiedInsertObj, ncMeta);
                    break;
            }
        }
    }
    static async insertColumn(context, param, ncMeta = _Noco.default.ncMeta) {
        const view = await this.get(context, param.view_id, ncMeta);
        let col;
        switch(view.type){
            case _nocodbsdk.ViewTypes.GRID:
                {
                    col = await _GridViewColumn.default.insert(context, _extends({}, param, {
                        fk_view_id: view.id
                    }), ncMeta);
                }
                break;
            case _nocodbsdk.ViewTypes.GALLERY:
                {
                    col = await _GalleryViewColumn.default.insert(context, _extends({}, param, {
                        fk_view_id: view.id
                    }), ncMeta);
                }
                break;
            case _nocodbsdk.ViewTypes.MAP:
                {
                    col = await _MapViewColumn.default.insert(context, _extends({}, param, {
                        fk_view_id: view.id
                    }), ncMeta);
                }
                break;
            case _nocodbsdk.ViewTypes.LIST:
                {
                    col = await _ListViewColumn.default.insert(context, _extends({}, param, {
                        fk_view_id: view.id
                    }), ncMeta);
                }
                break;
            case _nocodbsdk.ViewTypes.FORM:
                {
                    col = await _FormViewColumn.default.insert(context, _extends({}, param, {
                        fk_view_id: view.id
                    }), ncMeta);
                }
                break;
            case _nocodbsdk.ViewTypes.KANBAN:
                {
                    col = await _KanbanViewColumn.default.insert(context, _extends({}, param, {
                        fk_view_id: view.id
                    }), ncMeta);
                }
                break;
            case _nocodbsdk.ViewTypes.CALENDAR:
                {
                    col = await _CalendarViewColumn.default.insert(context, _extends({}, param, {
                        fk_view_id: view.id
                    }), ncMeta);
                }
                break;
        }
        return col;
    }
    static async listWithInfo(context, id, ncMeta = _Noco.default.ncMeta) {
        const list = await this.list(context, id, ncMeta);
        for (const item of list){
            await item.getViewWithInfo(context, ncMeta);
        }
        return list;
    }
    static async getColumns(context, viewId, ncMeta = _Noco.default.ncMeta) {
        let columns = [];
        const view = await this.get(context, viewId, ncMeta);
        // todo:  just get - order & show props
        switch(view.type){
            case _nocodbsdk.ViewTypes.GRID:
                columns = await _GridViewColumn.default.list(context, viewId, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.GALLERY:
                columns = await _GalleryViewColumn.default.list(context, viewId, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.MAP:
                columns = await _MapViewColumn.default.list(context, viewId, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.LIST:
                columns = await _ListViewColumn.default.list(context, viewId, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.FORM:
                columns = await _FormViewColumn.default.list(context, viewId, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.KANBAN:
                columns = await _KanbanViewColumn.default.list(context, viewId, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.CALENDAR:
                columns = await _CalendarViewColumn.default.list(context, viewId, ncMeta);
                break;
        }
        return columns;
    }
    static async getViewColumnId(context, { viewId, colId }, ncMeta = _Noco.default.ncMeta) {
        const view = await this.get(context, viewId);
        if (!view) return undefined;
        let tableName;
        let cacheScope;
        switch(view.type){
            case _nocodbsdk.ViewTypes.GRID:
                tableName = _globals.MetaTable.GRID_VIEW_COLUMNS;
                cacheScope = _globals.CacheScope.GRID_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.GALLERY:
                tableName = _globals.MetaTable.GALLERY_VIEW_COLUMNS;
                cacheScope = _globals.CacheScope.GALLERY_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.MAP:
                tableName = _globals.MetaTable.MAP_VIEW_COLUMNS;
                cacheScope = _globals.CacheScope.MAP_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.LIST:
                tableName = _globals.MetaTable.LIST_VIEW_COLUMNS;
                cacheScope = _globals.CacheScope.LIST_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.FORM:
                tableName = _globals.MetaTable.FORM_VIEW_COLUMNS;
                cacheScope = _globals.CacheScope.FORM_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.KANBAN:
                tableName = _globals.MetaTable.KANBAN_VIEW_COLUMNS;
                cacheScope = _globals.CacheScope.KANBAN_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.CALENDAR:
                tableName = _globals.MetaTable.CALENDAR_VIEW_COLUMNS;
                cacheScope = _globals.CacheScope.CALENDAR_VIEW_COLUMN;
                break;
        }
        const key = `${cacheScope}:viewColumnId:${colId}`;
        const o = await _NocoCache.default.get(context, key, _globals.CacheGetType.TYPE_STRING);
        if (o) return o;
        const viewColumn = await ncMeta.metaGet2(context.workspace_id, context.base_id, tableName, {
            fk_view_id: viewId,
            fk_column_id: colId
        });
        if (!viewColumn) return undefined;
        await _NocoCache.default.set(context, key, viewColumn.id);
        return viewColumn.id;
    }
    static async updateColumn(context, viewId, colId, colData, ncMeta = _Noco.default.ncMeta) {
        const view = await this.get(context, viewId, ncMeta);
        let table;
        let cacheScope;
        switch(view.type){
            case _nocodbsdk.ViewTypes.GRID:
                table = _globals.MetaTable.GRID_VIEW_COLUMNS;
                cacheScope = _globals.CacheScope.GRID_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.MAP:
                table = _globals.MetaTable.MAP_VIEW_COLUMNS;
                cacheScope = _globals.CacheScope.MAP_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.LIST:
                table = _globals.MetaTable.LIST_VIEW_COLUMNS;
                cacheScope = _globals.CacheScope.LIST_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.GALLERY:
                table = _globals.MetaTable.GALLERY_VIEW_COLUMNS;
                cacheScope = _globals.CacheScope.GALLERY_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.KANBAN:
                table = _globals.MetaTable.KANBAN_VIEW_COLUMNS;
                cacheScope = _globals.CacheScope.KANBAN_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.FORM:
                table = _globals.MetaTable.FORM_VIEW_COLUMNS;
                cacheScope = _globals.CacheScope.FORM_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.CALENDAR:
                table = _globals.MetaTable.CALENDAR_VIEW_COLUMNS;
                cacheScope = _globals.CacheScope.CALENDAR_VIEW_COLUMN;
        }
        let updateObj = (0, _extractProps.extractProps)(colData, [
            'order',
            'show'
        ]);
        // keep primary_value_column always visible and first in grid view
        if (view.type === _nocodbsdk.ViewTypes.GRID) {
            let primary_value_column_meta = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, {
                fk_model_id: view.fk_model_id,
                pv: true
            });
            if (!primary_value_column_meta) {
                const metaColumns = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, {
                    xcCondition: (qb)=>{
                        qb.where('fk_model_id', view.fk_model_id);
                        qb.andWhere((subQb)=>{
                            subQb.where('system', false).orWhereNull('system');
                        });
                    },
                    orderBy: {
                        order: 'asc'
                    }
                });
                primary_value_column_meta = metaColumns.find((col)=>(0, _nocodbsdk.isSupportedDisplayValueColumn)(col));
                if (!primary_value_column_meta) {
                    _ncError.NcError.get(context).internalServerError(`No display field setup for table`);
                }
                await _Column.default.update(context, primary_value_column_meta.id, {
                    pv: true
                });
            }
            const primary_value_column = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.GRID_VIEW_COLUMNS, {
                fk_view_id: view.id,
                fk_column_id: primary_value_column_meta.id
            });
            if (primary_value_column && primary_value_column.id === colId) {
                updateObj.order = 1;
                updateObj.show = true;
            }
        }
        if (view.type === _nocodbsdk.ViewTypes.CALENDAR) {
            updateObj = _extends({}, updateObj, (0, _extractProps.extractProps)(colData, [
                'underline',
                'bold',
                'italic'
            ]));
        }
        // set meta
        const res = await ncMeta.metaUpdate(context.workspace_id, context.base_id, table, updateObj, colId);
        await _NocoCache.default.update(context, `${cacheScope}:${colId}`, updateObj);
        // on view column update, delete corresponding single query cache
        await View.clearSingleQueryCache(context, view.fk_model_id, [
            view
        ], ncMeta);
        return res;
    }
    static async getColumn(context, viewId, colId, ncMeta = _Noco.default.ncMeta) {
        const view = await this.get(context, viewId, ncMeta);
        switch(view.type){
            case _nocodbsdk.ViewTypes.GRID:
                return _GridViewColumn.default.get(context, colId, ncMeta);
            case _nocodbsdk.ViewTypes.MAP:
                return _MapViewColumn.default.get(context, colId, ncMeta);
            case _nocodbsdk.ViewTypes.LIST:
                return _ListViewColumn.default.get(context, colId, ncMeta);
            case _nocodbsdk.ViewTypes.GALLERY:
                return _GalleryViewColumn.default.get(context, colId, ncMeta);
            case _nocodbsdk.ViewTypes.KANBAN:
                return _KanbanViewColumn.default.get(context, colId, ncMeta);
            case _nocodbsdk.ViewTypes.FORM:
                return _FormViewColumn.default.get(context, colId, ncMeta);
            case _nocodbsdk.ViewTypes.CALENDAR:
                return _CalendarViewColumn.default.get(context, colId, ncMeta);
        }
        return null;
    }
    static async insertOrUpdateColumn(context, viewId, fkColId, colData, ncMeta = _Noco.default.ncMeta) {
        const view = await this.get(context, viewId, ncMeta);
        const table = this.extractViewColumnsTableName(view);
        const existingCol = await ncMeta.metaGet2(context.workspace_id, context.base_id, table, {
            fk_view_id: viewId,
            fk_column_id: fkColId
        });
        if (existingCol) {
            await ncMeta.metaUpdate(context.workspace_id, context.base_id, table, {
                order: colData.order,
                show: colData.show
            }, existingCol.id);
            // on view column update, delete any optimised single query cache
            await View.clearSingleQueryCache(context, view.fk_model_id, [
                view
            ], ncMeta);
            return _extends({}, existingCol, colData);
        } else {
            switch(view.type){
                case _nocodbsdk.ViewTypes.GRID:
                    return await _GridViewColumn.default.insert(context, {
                        fk_view_id: viewId,
                        fk_column_id: fkColId,
                        order: colData.order,
                        show: colData.show
                    }, ncMeta);
                case _nocodbsdk.ViewTypes.GALLERY:
                    return await _GalleryViewColumn.default.insert(context, {
                        fk_view_id: viewId,
                        fk_column_id: fkColId,
                        order: colData.order,
                        show: colData.show
                    }, ncMeta);
                case _nocodbsdk.ViewTypes.KANBAN:
                    return await _KanbanViewColumn.default.insert(context, {
                        fk_view_id: viewId,
                        fk_column_id: fkColId,
                        order: colData.order,
                        show: colData.show
                    }, ncMeta);
                case _nocodbsdk.ViewTypes.MAP:
                    return await _MapViewColumn.default.insert(context, {
                        fk_view_id: viewId,
                        fk_column_id: fkColId,
                        order: colData.order,
                        show: colData.show
                    }, ncMeta);
                case _nocodbsdk.ViewTypes.LIST:
                    return await _ListViewColumn.default.insert(context, {
                        fk_view_id: viewId,
                        fk_column_id: fkColId,
                        order: colData.order,
                        show: colData.show
                    }, ncMeta);
                case _nocodbsdk.ViewTypes.FORM:
                    return await _FormViewColumn.default.insert(context, {
                        fk_view_id: viewId,
                        fk_column_id: fkColId,
                        order: colData.order,
                        show: colData.show
                    }, ncMeta);
                case _nocodbsdk.ViewTypes.CALENDAR:
                    return await _CalendarViewColumn.default.insert(context, {
                        fk_view_id: viewId,
                        fk_column_id: fkColId,
                        order: colData.order,
                        show: colData.show
                    }, ncMeta);
            }
            return await ncMeta.metaInsert2(context.workspace_id, context.base_id, table, {
                source_id: view.source_id,
                fk_view_id: viewId,
                fk_column_id: fkColId,
                order: colData.order,
                show: colData.show
            });
        }
    }
    // todo: cache
    static async getByUUID(context, uuid, ncMeta = _Noco.default.ncMeta) {
        const view = await ncMeta.metaGet2(_globals.RootScopes.FULL_BYPASS, _globals.RootScopes.FULL_BYPASS, _globals.MetaTable.VIEWS, {
            uuid
        });
        if (view) {
            view.meta = (0, _modelUtils.parseMetaProp)(view);
        }
        return view && new View(view);
    }
    static async share(context, viewId, ncMeta = _Noco.default.ncMeta) {
        const view = await this.get(context, viewId);
        if (!view.uuid) {
            const uuid = uuidv4();
            view.uuid = uuid;
            // set meta
            await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.VIEWS, {
                uuid: view.uuid
            }, viewId);
            await _NocoCache.default.update(context, `${_globals.CacheScope.VIEW}:${view.id}`, {
                uuid: view.uuid
            });
        }
        if (!view.meta || !('allowCSVDownload' in view.meta)) {
            var _view_meta;
            const defaultMeta = _extends({}, (_view_meta = view.meta) != null ? _view_meta : {}, {
                allowCSVDownload: true
            });
            view.meta = defaultMeta;
            // set meta
            await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.VIEWS, (0, _modelUtils.prepareForDb)({
                meta: defaultMeta
            }), viewId);
            await _NocoCache.default.update(context, `${_globals.CacheScope.VIEW}:${view.id}`, (0, _modelUtils.prepareForResponse)({
                meta: defaultMeta
            }));
        }
        return view;
    }
    static async passwordUpdate(context, viewId, { password }, ncMeta = _Noco.default.ncMeta) {
        const hashedPassword = password ? await _bcryptjs.default.hash(password, 10) : password;
        // set meta
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.VIEWS, {
            password: hashedPassword
        }, viewId);
        await _NocoCache.default.update(context, `${_globals.CacheScope.VIEW}:${viewId}`, {
            password: hashedPassword
        });
    }
    static async verifyPassword(view, inputPassword) {
        if (!view.password) return true;
        if (!inputPassword) return false;
        // Support bcrypt hashed passwords (new) and plaintext (legacy)
        if (view.password.startsWith('$2a$') || view.password.startsWith('$2b$')) {
            return _bcryptjs.default.compare(inputPassword, view.password);
        }
        // Plaintext fallback for pre-migration passwords
        return view.password === inputPassword;
    }
    static async sharedViewDelete(context, viewId, ncMeta = _Noco.default.ncMeta) {
        // set meta
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.VIEWS, _extends({
            uuid: null
        }, _utils.isEE ? {
            fk_custom_url_id: null
        } : {}), viewId);
        await _models.CustomUrl.delete({
            view_id: viewId
        });
        await _NocoCache.default.update(context, `${_globals.CacheScope.VIEW}:${viewId}`, _extends({
            uuid: null
        }, _utils.isEE ? {
            fk_custom_url_id: null
        } : {}));
    }
    static async update(context, viewId, body, includeCreatedByAndUpdateBy = false, ncMeta = _Noco.default.ncMeta) {
        const updateObj = (0, _extractProps.extractProps)(body, [
            'title',
            'order',
            'description',
            'show_system_fields',
            'lock_type',
            'password',
            'meta',
            'uuid',
            'row_coloring_mode',
            ..._utils.isEE ? [
                'fk_custom_url_id'
            ] : [],
            ..._utils.isEE ? [
                'fk_view_section_id'
            ] : [],
            ...includeCreatedByAndUpdateBy ? [
                'owned_by',
                'created_by'
            ] : [],
            ..._utils.isEE ? [
                'expanded_record_mode',
                'attachment_mode_column_id'
            ] : []
        ]);
        // Hash shared view password before storage
        if (updateObj.password) {
            updateObj.password = await _bcryptjs.default.hash(updateObj.password, 10);
        }
        if (_utils.isEE) {
            if (!(updateObj == null ? void 0 : updateObj.attachment_mode_column_id)) {
                updateObj.expanded_record_mode = _nocodbsdk.ExpandedFormMode.FIELD;
            } else {
                updateObj.expanded_record_mode = _nocodbsdk.ExpandedFormMode.ATTACHMENT;
            }
        }
        const oldView = await this.get(context, viewId, ncMeta);
        // set meta
        await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.VIEWS, (0, _modelUtils.prepareForDb)(updateObj), viewId);
        // reset alias cache
        await _NocoCache.default.del(context, `${_globals.CacheScope.VIEW}:${oldView.fk_model_id}:${oldView.title}`);
        await _NocoCache.default.update(context, `${_globals.CacheScope.VIEW}:${viewId}`, (0, _modelUtils.prepareForResponse)(updateObj));
        // Get the first collaborative grid view to update default view cache
        const defaultView = (0, _nocodbsdk.getFirstNonPersonalView)(await this.list(context, oldView.fk_model_id, ncMeta), {
            includeViewType: _nocodbsdk.ViewTypes.GRID
        });
        // Update the default view cache if the first collaborative grid view has changed
        if (defaultView) {
            await _NocoCache.default.set(context, `${_globals.CacheScope.VIEW}:${oldView.fk_model_id}:default`, defaultView);
        }
        const view = await this.get(context, viewId, ncMeta);
        if (view.type === _nocodbsdk.ViewTypes.GRID) {
            if ('show_system_fields' in updateObj) {
                await View.fixPVColumnForView(context, viewId, ncMeta);
            }
        }
        // on update, delete any optimised single query cache
        await View.clearSingleQueryCache(context, view.fk_model_id, [
            view
        ], ncMeta);
        (0, _commandPaletteHelpers.cleanCommandPaletteCache)(context.workspace_id).catch(()=>{
            logger.error('Failed to clean command palette cache');
        });
        (0, _scriptHelper.cleanBaseSchemaCacheForBase)(context.base_id).catch(()=>{
            logger.error('Failed to clean base schema cache');
        });
        return view;
    }
    // @ts-ignore
    static async delete(context, viewId, ncMeta = _Noco.default.ncMeta) {
        const view = await this.get(context, viewId, ncMeta);
        await _Sort.default.deleteAll(context, viewId, ncMeta);
        await _Filter.default.deleteAll(context, viewId, ncMeta);
        const table = this.extractViewTableName(view);
        const tableScope = this.extractViewTableNameScope(view);
        const columnTable = this.extractViewColumnsTableName(view);
        const columnTableScope = this.extractViewColumnsTableNameScope(view);
        await _rowColorViewHelpers.RowColorViewHelpers.withContext(context, {
            ncMeta
        }).viewDeleted(view);
        await ncMeta.metaDelete(context.workspace_id, context.base_id, columnTable, {
            fk_view_id: viewId
        });
        await ncMeta.metaDelete(context.workspace_id, context.base_id, table, {
            fk_view_id: viewId
        });
        await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.VIEWS, viewId);
        await _NocoCache.default.deepDel(context, `${tableScope}:${viewId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        // For Calendar View, delete the range associated with viewId
        if (view.type === _nocodbsdk.ViewTypes.CALENDAR) {
            await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW_RANGE, {
                fk_view_id: viewId
            });
            await _NocoCache.default.deepDel(context, `${_globals.CacheScope.CALENDAR_VIEW_RANGE}:${viewId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        }
        // For List View, delete the levels associated with viewId
        if (view.type === _nocodbsdk.ViewTypes.LIST) {
            await ncMeta.metaDelete(context.workspace_id, context.base_id, _globals.MetaTable.LIST_VIEW_LEVELS, {
                fk_view_id: viewId
            });
            await _NocoCache.default.deepDel(context, `${_globals.CacheScope.LIST_VIEW_LEVEL}:${viewId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        }
        await _NocoCache.default.deepDel(context, `${columnTableScope}:${viewId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        await _NocoCache.default.deepDel(context, `${_globals.CacheScope.VIEW}:${viewId}`, _globals.CacheDelDirection.CHILD_TO_PARENT);
        await _NocoCache.default.del(context, [
            `${_globals.CacheScope.VIEW_ALIAS}:${view.fk_model_id}:${view.title}`,
            `${_globals.CacheScope.VIEW_ALIAS}:${view.fk_model_id}:${view.id}`
        ]);
        if (view == null ? void 0 : view.id) {
            // get all Links associated with the view and remove the view from the link
            const links = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.COL_RELATIONS, {
                condition: {
                    fk_target_view_id: view.id
                }
            });
            const contextRef = _extends({}, context);
            for (const link of links){
                await _models.LinkToAnotherRecordColumn.update(context, link.fk_column_id, {
                    fk_target_view_id: null
                });
                // notify all sockets of the change in the related column
                (async (l)=>{
                    _NocoSocket.default.broadcastEvent(contextRef, {
                        event: _nocodbsdk.EventType.META_EVENT,
                        payload: {
                            action: 'column_update',
                            payload: await _Column.default.get(context, {
                                colId: l.fk_column_id
                            }, ncMeta).then(async (col)=>({
                                    column: col,
                                    table: await _Model.default.getWithInfo(context, {
                                        id: col.fk_model_id
                                    }, ncMeta),
                                    skipDataReload: true
                                }))
                        }
                    });
                })(link).catch((err)=>{
                    console.log(`Error in related column cache clear:`, err);
                });
            }
        }
        // on update, delete any optimised single query cache
        await View.clearSingleQueryCache(context, view.fk_model_id, [
            view
        ], ncMeta);
        if (_utils.isEE && view.fk_custom_url_id) {
            _models.CustomUrl.delete({
                id: view.fk_custom_url_id
            }).catch(()=>{
                logger.error(`Failed to delete custom urls of viewId: ${view.id}`);
            });
        }
        (0, _commandPaletteHelpers.cleanCommandPaletteCache)(context.workspace_id).catch(()=>{
            logger.error('Failed to clean command palette cache');
        });
        (0, _scriptHelper.cleanBaseSchemaCacheForBase)(context.base_id).catch(()=>{
            logger.error('Failed to clean base schema cache');
        });
    }
    static async showAllColumns(context, viewId, ignoreColdIds = [], ncMeta = _Noco.default.ncMeta, levelId) {
        const view = await this.get(context, viewId);
        const table = this.extractViewColumnsTableName(view);
        const scope = this.extractViewColumnsTableNameScope(view);
        const columns = await view.getModel(context, ncMeta).then((meta)=>meta.getColumns(context, ncMeta));
        const viewColumns = await this.getColumns(context, viewId, ncMeta);
        const availableColumnsInView = viewColumns.map((column)=>column.fk_column_id);
        // get existing cache
        const cachedList = await _NocoCache.default.getList(context, scope, [
            viewId
        ]);
        const { list: dataList } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && (dataList == null ? void 0 : dataList.length)) {
            for (const o of dataList){
                if (levelId && o.fk_level_id !== levelId) continue;
                if (!(ignoreColdIds == null ? void 0 : ignoreColdIds.length) || !ignoreColdIds.includes(o.fk_column_id)) {
                    // set data
                    o.show = true;
                    // set cache
                    await _NocoCache.default.set(context, `${scope}:${o.id}`, o);
                }
            }
        }
        // insert or update view column
        for (const col of columns){
            if (ignoreColdIds == null ? void 0 : ignoreColdIds.includes(col.id)) continue;
            const colIndex = availableColumnsInView.indexOf(col.id);
            if (colIndex > -1) {
                // Skip columns not belonging to the specified level
                if (levelId && viewColumns[colIndex].fk_level_id !== levelId) continue;
                await this.updateColumn(context, viewId, viewColumns[colIndex].id, {
                    show: true
                }, ncMeta);
            } else if (!levelId) {
                // Only insert new columns when not level-scoped
                await this.insertColumn(context, {
                    view_id: viewId,
                    order: await ncMeta.metaGetNextOrder(table, {
                        fk_view_id: viewId
                    }),
                    show: true,
                    fk_column_id: col.id
                }, ncMeta);
            }
        // return await ncMeta.metaUpdate(
        // context.workspace_id,
        // context.base_id,
        //   table,
        //   { show: true },
        //   {
        //     fk_view_id: viewId,
        //   },
        //   ignoreColdIds?.length
        //     ? {
        //         _not: {
        //           fk_column_id: {
        //             in: ignoreColdIds,
        //           },
        //         },
        //       }
        //     : null
        // );
        }
    }
    static async hideAllColumns(context, viewId, ignoreColdIds = [], ncMeta = _Noco.default.ncMeta, levelId) {
        const view = await this.get(context, viewId, ncMeta);
        const table = this.extractViewColumnsTableName(view);
        const scope = this.extractViewColumnsTableNameScope(view);
        if (view.type === _nocodbsdk.ViewTypes.GRID) {
            const primary_value_column = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, {
                fk_model_id: view.fk_model_id,
                pv: true
            });
            // keep primary_value_column always visible
            if (primary_value_column) {
                ignoreColdIds.push(primary_value_column.id);
            }
        }
        // get existing cache
        const cachedList = await _NocoCache.default.getList(context, scope, [
            viewId
        ]);
        const { list: dataList } = cachedList;
        const { isNoneList } = cachedList;
        const colsEssentialForView = view.type === _nocodbsdk.ViewTypes.MAP ? [
            (await _MapView.default.get(context, viewId, ncMeta)).fk_geo_data_col_id
        ] : [];
        const mergedIgnoreColdIds = [
            ...ignoreColdIds,
            ...colsEssentialForView
        ];
        if (!isNoneList && (dataList == null ? void 0 : dataList.length)) {
            for (const o of dataList){
                if (levelId && o.fk_level_id !== levelId) continue;
                if (!(mergedIgnoreColdIds == null ? void 0 : mergedIgnoreColdIds.length) || !mergedIgnoreColdIds.includes(o.fk_column_id)) {
                    // set data
                    o.show = false;
                    // set cache
                    await _NocoCache.default.set(context, `${scope}:${o.id}`, o);
                }
            }
        }
        // set meta
        const condition = {
            fk_view_id: viewId
        };
        if (levelId) {
            condition.fk_level_id = levelId;
        }
        return await ncMeta.metaUpdate(context.workspace_id, context.base_id, table, {
            show: false
        }, condition, (mergedIgnoreColdIds == null ? void 0 : mergedIgnoreColdIds.length) ? {
            _not: {
                fk_column_id: {
                    in: ignoreColdIds
                }
            }
        } : null);
    }
    static async getSharedViewPath(context, viewId, ncMeta = _Noco.default.ncMeta) {
        var _parseProp;
        const view = await this.get(context, viewId, ncMeta);
        if (!view.uuid) return null;
        let viewType;
        switch(view.type){
            case _nocodbsdk.ViewTypes.FORM:
                viewType = 'form';
                break;
            case _nocodbsdk.ViewTypes.KANBAN:
                viewType = 'kanban';
                break;
            case _nocodbsdk.ViewTypes.GALLERY:
                viewType = 'gallery';
                break;
            case _nocodbsdk.ViewTypes.MAP:
                viewType = 'map';
                break;
            case _nocodbsdk.ViewTypes.LIST:
                viewType = 'list';
                break;
            case _nocodbsdk.ViewTypes.CALENDAR:
                viewType = 'calendar';
                break;
            default:
                viewType = 'view';
        }
        return `${encodeURI(`/nc/${viewType}/${view.uuid}${((_parseProp = (0, _nocodbsdk.parseProp)(view.meta)) == null ? void 0 : _parseProp.surveyMode) ? '/survey' : ''}`)}`;
    }
    static async shareViewList(context, tableId, ncMeta = _Noco.default.ncMeta) {
        const cachedList = await _NocoCache.default.getList(context, _globals.CacheScope.VIEW, [
            tableId
        ]);
        let { list: sharedViews } = cachedList;
        const { isNoneList } = cachedList;
        if (!isNoneList && !sharedViews.length) {
            sharedViews = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.VIEWS, {
                xcCondition: {
                    fk_model_id: {
                        eq: tableId
                    },
                    _not: {
                        uuid: {
                            eq: null
                        }
                    }
                }
            });
            await _NocoCache.default.setList(context, _globals.CacheScope.VIEW, [
                tableId
            ], sharedViews);
        }
        sharedViews = sharedViews.filter((v)=>v.uuid !== null);
        return sharedViews == null ? void 0 : sharedViews.map((v)=>new View(v));
    }
    static async fixPVColumnForView(context, viewId, ncMeta = _Noco.default.ncMeta) {
        // get a list of view columns sorted by order
        const view_columns = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.GRID_VIEW_COLUMNS, {
            condition: {
                fk_view_id: viewId
            },
            orderBy: {
                order: 'asc'
            }
        });
        const view_columns_meta = [];
        // get column meta for each view column
        for (const col of view_columns){
            const col_meta = await ncMeta.metaGet2(context.workspace_id, context.base_id, _globals.MetaTable.COLUMNS, col.fk_column_id);
            if (col_meta) view_columns_meta.push(col_meta);
        }
        const primary_value_column_meta = view_columns_meta.find((col)=>col.pv);
        if (primary_value_column_meta) {
            const primary_value_column = view_columns.find((col)=>col.fk_column_id === primary_value_column_meta.id);
            const primary_value_column_index = view_columns.findIndex((col)=>col.fk_column_id === primary_value_column_meta.id);
            const view_orders = view_columns.map((col)=>col.order);
            const view_min_order = Math.min(...view_orders);
            // if primary_value_column is not visible, make it visible
            if (!primary_value_column.show) {
                await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.GRID_VIEW_COLUMNS, {
                    show: true
                }, primary_value_column.id);
                await _NocoCache.default.set(context, `${_globals.CacheScope.GRID_VIEW_COLUMN}:${primary_value_column.id}`, primary_value_column);
            }
            if (primary_value_column.order === view_min_order && view_orders.filter((o)=>o === view_min_order).length === 1) {
                // if primary_value_column is in first order do nothing
                return;
            } else {
                // if primary_value_column not in first order, move it to the start of array
                if (primary_value_column_index !== 0) {
                    const temp_pv = view_columns.splice(primary_value_column_index, 1);
                    view_columns.unshift(...temp_pv);
                }
                // update order of all columns in view to match the order in array
                for(let i = 0; i < view_columns.length; i++){
                    await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.GRID_VIEW_COLUMNS, {
                        order: i + 1
                    }, view_columns[i].id);
                    await _NocoCache.default.set(context, `${_globals.CacheScope.GRID_VIEW_COLUMN}:${view_columns[i].id}`, view_columns[i]);
                }
            }
        }
        const views = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.GRID_VIEW_COLUMNS, {
            condition: {
                fk_view_id: viewId
            },
            orderBy: {
                order: 'asc'
            }
        });
        await _NocoCache.default.setList(context, _globals.CacheScope.GRID_VIEW_COLUMN, [
            viewId
        ], views);
    }
    static async clearSingleQueryCache(context, modelId, views, ncMeta = _Noco.default.ncMeta) {
        if (!_Noco.default.isEE()) return;
        // get all views of the model
        let viewsList = views || (await _NocoCache.default.getList(context, _globals.CacheScope.VIEW, [
            modelId
        ])).list;
        if (!views && !(viewsList == null ? void 0 : viewsList.length)) {
            viewsList = await ncMeta.metaList2(context.workspace_id, context.base_id, _globals.MetaTable.VIEWS, {
                condition: {
                    fk_model_id: modelId
                }
            });
        }
        const deleteKeys = [];
        for (const view of viewsList){
            deleteKeys.push(`${_globals.CacheScope.SINGLE_QUERY}:${modelId}:${view.id}:queries`, `${_globals.CacheScope.SINGLE_QUERY}:${modelId}:${view.id}:queries:ltar`, `${_globals.CacheScope.SINGLE_QUERY}:${modelId}:${view.id}:count`);
            // Add all 16 combinations of bitwise flags (0-15)
            for(let flags = 0; flags < 16; flags++){
                deleteKeys.push(`${_globals.CacheScope.SINGLE_QUERY}:${modelId}:${view.id}:read:${flags}`);
            }
        }
        deleteKeys.push(`${_globals.CacheScope.SINGLE_QUERY}:${modelId}:default:queries`, `${_globals.CacheScope.SINGLE_QUERY}:${modelId}:default:queries:ltar`, `${_globals.CacheScope.SINGLE_QUERY}:${modelId}:default:count`);
        // Add all 16 combinations of bitwise flags (0-15)
        for(let flags = 0; flags < 16; flags++){
            deleteKeys.push(`${_globals.CacheScope.SINGLE_QUERY}:${modelId}:default:read:${flags}`);
        }
        // Delete tracked RLS-specific cache keys (stored as Redis SET)
        const rlsTrackingKey = `${_globals.CacheScope.SINGLE_QUERY}:${modelId}:rls_keys`;
        const rlsKeys = await _NocoCache.default.get(context, rlsTrackingKey, _globals.CacheGetType.TYPE_ARRAY);
        if (rlsKeys == null ? void 0 : rlsKeys.length) {
            deleteKeys.push(...rlsKeys.filter((k)=>k && k !== 'NONE'), rlsTrackingKey);
        }
        await _NocoCache.default.del(context, deleteKeys);
    }
    static async bulkColumnInsertToViews(context, { columns, viewColumns, copyFromView }, view, ncMeta = _Noco.default.ncMeta) {
        const insertObjs = [];
        if (viewColumns) {
            for(let i = 0; i < viewColumns.length; i++){
                const column = view.type === _nocodbsdk.ViewTypes.FORM ? (0, _modelUtils.prepareForDb)(viewColumns[i]) : viewColumns[i];
                insertObjs.push(_extends({}, (0, _extractProps.extractProps)(column, [
                    'fk_view_id',
                    'fk_column_id',
                    'show',
                    'base_id',
                    'source_id',
                    'order',
                    ...view.type === _nocodbsdk.ViewTypes.CALENDAR ? [
                        'bold',
                        'italic',
                        'underline'
                    ] : [],
                    ...view.type === _nocodbsdk.ViewTypes.FORM ? [
                        'label',
                        'help',
                        'description',
                        'required',
                        'enable_scanner',
                        'meta'
                    ] : [
                        'width',
                        'group_by',
                        'group_by_order',
                        'group_by_sort',
                        'aggregation'
                    ]
                ]), {
                    fk_view_id: view.id,
                    base_id: view.base_id,
                    source_id: view.source_id
                }));
            }
        } else {
            if (!columns) {
                columns = await _Column.default.list(context, {
                    fk_model_id: view.fk_model_id
                });
            }
            if (!copyFromView) {
                // sort by display value first, then other columns
                // so that later we can handle control `show` easily
                columns.sort((a, b)=>{
                    return +b.pv - +a.pv;
                });
            }
            let order = 1;
            let galleryShowLimit = 0;
            let kanbanShowLimit = 0;
            let calendarRangeColumns;
            if (view.type == _nocodbsdk.ViewTypes.CALENDAR) {
                const calendarRange = await _CalendarRange.default.read(context, view.id, ncMeta);
                if (calendarRange) {
                    calendarRangeColumns = calendarRange.ranges.map((range)=>[
                            range.fk_from_column_id,
                            range.fk_to_column_id
                        ]).flat();
                }
            }
            for(let i = 0; i < columns.length; i++){
                const column = columns[i];
                let show = 'show' in column ? column.show : true;
                const aggregation = _nocodbsdk.CommonAggregations.None;
                if (view.type === _nocodbsdk.ViewTypes.GALLERY) {
                    const galleryView = await _GalleryView.default.get(context, view.id, ncMeta);
                    // define the limit of columns to show in gallery view, excluding the cover image column and primary value column
                    const showLimit = galleryView.fk_cover_image_col_id ? 2 : 3;
                    if (column.id === galleryView.fk_cover_image_col_id && column.pv || column.id !== galleryView.fk_cover_image_col_id && (column.pv || galleryShowLimit < showLimit) && // exclude system columns
                    !column.system) {
                        show = true;
                        // increment the count of columns shown in gallery view if it is not a primary value or cover image column
                        if (!column.pk && column.id !== galleryView.fk_cover_image_col_id) {
                            galleryShowLimit++;
                        }
                    } else {
                        show = false;
                    }
                } else if (view.type === _nocodbsdk.ViewTypes.KANBAN && !copyFromView) {
                    const kanbanView = await _KanbanView.default.get(context, view.id, ncMeta);
                    if (column.id === (kanbanView == null ? void 0 : kanbanView.fk_grp_col_id) && column.pv) {
                        // include grouping field if it exists
                        show = true;
                    } else if (column.id === kanbanView.fk_cover_image_col_id && column.pv || column.id !== kanbanView.fk_cover_image_col_id && column.pv) {
                        // Show primary key and cover image if it is a primary value; otherwise, it will be redundant.
                        show = true;
                        kanbanShowLimit++;
                    } else if (column.id !== kanbanView.fk_cover_image_col_id && kanbanShowLimit < 3 && !(0, _nocodbsdk.isSystemColumn)(column)) {
                        // show at most 3 non-system columns
                        show = true;
                        kanbanShowLimit++;
                    } else {
                        // other columns will be hidden
                        show = false;
                    }
                } else if (view.type === _nocodbsdk.ViewTypes.MAP && !copyFromView) {
                    const mapView = await _MapView.default.get(context, view.id, ncMeta);
                    if (column.id === (mapView == null ? void 0 : mapView.fk_geo_data_col_id)) {
                        show = true;
                    }
                } else if (view.type === _nocodbsdk.ViewTypes.FORM && (0, _nocodbsdk.isSystemColumn)(column)) {
                    show = false;
                } else if (view.type === _nocodbsdk.ViewTypes.CALENDAR) {
                    if (!calendarRangeColumns) break;
                    if (calendarRangeColumns.includes(column.id)) {
                        show = true;
                    }
                }
                insertObjs.push(_extends({
                    fk_column_id: column.id,
                    order: order++,
                    show,
                    fk_view_id: view.id,
                    base_id: view.base_id,
                    source_id: view.source_id
                }, view.type === _nocodbsdk.ViewTypes.GRID ? {
                    aggregation
                } : {}));
            }
        }
        switch(view.type){
            case _nocodbsdk.ViewTypes.GRID:
                await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.GRID_VIEW_COLUMNS, insertObjs);
                break;
            case _nocodbsdk.ViewTypes.GALLERY:
                await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.GALLERY_VIEW_COLUMNS, insertObjs);
                break;
            case _nocodbsdk.ViewTypes.MAP:
                await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.MAP_VIEW_COLUMNS, insertObjs);
                break;
            case _nocodbsdk.ViewTypes.LIST:
                await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.LIST_VIEW_COLUMNS, insertObjs);
                break;
            case _nocodbsdk.ViewTypes.KANBAN:
                await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.KANBAN_VIEW_COLUMNS, insertObjs);
                break;
            case _nocodbsdk.ViewTypes.FORM:
                await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.FORM_VIEW_COLUMNS, insertObjs);
                break;
            case _nocodbsdk.ViewTypes.CALENDAR:
                await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.CALENDAR_VIEW_COLUMNS, insertObjs);
        }
    }
    static async insertMetaOnly(context, { view, model, req }, ncMeta = _Noco.default.ncMeta) {
        const insertObj = (0, _extractProps.extractProps)(view, [
            'id',
            'title',
            'description',
            'type',
            'fk_model_id',
            'base_id',
            'source_id',
            'meta',
            'created_by',
            'owned_by',
            'lock_type',
            ..._utils.isEE ? [
                'expanded_record_mode',
                'attachment_mode_column_id',
                'row_coloring_mode'
            ] : []
        ]);
        if (_utils.isEE) {
            if (!(insertObj == null ? void 0 : insertObj.attachment_mode_column_id)) {
                insertObj.expanded_record_mode = _nocodbsdk.ExpandedFormMode.FIELD;
            } else {
                insertObj.expanded_record_mode = _nocodbsdk.ExpandedFormMode.ATTACHMENT;
            }
        }
        if (!insertObj.order) {
            // get order value
            insertObj.order = await ncMeta.metaGetNextOrder(_globals.MetaTable.VIEWS, {
                fk_model_id: view.fk_model_id
            });
        }
        insertObj.show = true;
        if (!insertObj.meta) {
            insertObj.meta = {};
        }
        insertObj.meta = (0, _modelUtils.stringifyMetaProp)(insertObj);
        const copyFromView = view.copy_from_id && await View.get(context, view.copy_from_id, ncMeta);
        await (copyFromView == null ? void 0 : copyFromView.getView(context));
        const table = await _Model.default.getByIdOrName(context, {
            id: view.fk_model_id
        }, ncMeta);
        // get base and base id if missing
        if (!view.source_id) {
            insertObj.source_id = table.source_id;
        }
        const insertedView = await ncMeta.metaInsert2(context.workspace_id, context.base_id, _globals.MetaTable.VIEWS, insertObj);
        const { id: view_id } = insertedView;
        // Map old level IDs to new level IDs for sort/filter duplication (list view)
        const levelIdMap = new Map();
        let defaultLevelId;
        // insert view metadata based on view type
        switch(view.type){
            case _nocodbsdk.ViewTypes.GRID:
                await _GridView.default.insert(context, _extends({}, (copyFromView == null ? void 0 : copyFromView.view) || {}, view, {
                    fk_view_id: view_id
                }), ncMeta);
                break;
            case _nocodbsdk.ViewTypes.MAP:
                await _MapView.default.insert(context, _extends({}, view, {
                    fk_view_id: view_id
                }), ncMeta);
                break;
            case _nocodbsdk.ViewTypes.LIST:
                {
                    await _ListView.default.insert(context, _extends({}, (copyFromView == null ? void 0 : copyFromView.view) || {}, view, {
                        fk_view_id: view_id
                    }), ncMeta);
                    if (copyFromView == null ? void 0 : copyFromView.view) {
                        const sourceLevels = await _ListViewLevel.default.list(context, copyFromView.id, ncMeta);
                        for (const level of sourceLevels){
                            const newLevel = await _ListViewLevel.default.insert(context, _extends({}, (0, _extractProps.extractProps)(level, [
                                'level',
                                'fk_model_id',
                                'fk_link_column_id',
                                'enable_nested_records',
                                'fk_self_link_column_id',
                                'meta'
                            ]), {
                                fk_view_id: view_id
                            }), ncMeta);
                            if (level.id && (newLevel == null ? void 0 : newLevel.id)) {
                                levelIdMap.set(level.id, newLevel.id);
                            }
                            if (level.fk_model_id === view.fk_model_id && (newLevel == null ? void 0 : newLevel.id)) {
                                defaultLevelId = newLevel.id;
                            }
                        }
                    } else {
                        // Auto-create level 0 with the view's table
                        const defaultLevel = await _ListViewLevel.default.insert(context, {
                            fk_view_id: view_id,
                            level: 0,
                            fk_model_id: view.fk_model_id
                        }, ncMeta);
                        defaultLevelId = defaultLevel == null ? void 0 : defaultLevel.id;
                    }
                    break;
                }
            case _nocodbsdk.ViewTypes.GALLERY:
                await _GalleryView.default.insert(context, _extends({}, (copyFromView == null ? void 0 : copyFromView.view) || {}, view, {
                    fk_view_id: view_id
                }), ncMeta);
                break;
            case _nocodbsdk.ViewTypes.FORM:
                await _FormView.default.insert(context, _extends({
                    heading: view.title
                }, (copyFromView == null ? void 0 : copyFromView.view) || {}, view, {
                    fk_view_id: view_id
                }), ncMeta);
                break;
            case _nocodbsdk.ViewTypes.KANBAN:
                // set grouping field
                view.fk_grp_col_id = view.fk_grp_col_id;
                await _KanbanView.default.insert(context, _extends({}, (copyFromView == null ? void 0 : copyFromView.view) || {}, view, {
                    fk_view_id: view_id
                }), ncMeta);
                break;
            case _nocodbsdk.ViewTypes.CALENDAR:
                {
                    const obj = (0, _extractProps.extractProps)(view, [
                        'calendar_range'
                    ]);
                    if (!obj.calendar_range) break;
                    const calendarRange = obj.calendar_range;
                    calendarRange.forEach((range)=>{
                        range.fk_view_id = view_id;
                    });
                    await _CalendarRange.default.bulkInsert(context, calendarRange, ncMeta);
                    await _CalendarView.default.insert(context, _extends({}, (copyFromView == null ? void 0 : copyFromView.view) || {}, view, {
                        fk_view_id: view_id
                    }), ncMeta);
                    break;
                }
        }
        try {
            // copy from view
            if (copyFromView) {
                // generate parent audit id and add it to req object
                const eventId = await _Noco.default.ncAudit.genNanoid(_globals.MetaTable.AUDIT);
                req.ncParentAuditId = eventId;
                _Noco.default.appHooksService.emit(_nocodbsdk.AppEvents.VIEW_DUPLICATE_START, {
                    sourceView: copyFromView,
                    destView: view,
                    req,
                    context,
                    id: eventId
                });
                const duplicateRowColorConditions = await _rowColorViewHelpers.RowColorViewHelpers.withContext(context).getDuplicateRowColorConditions({
                    views: [
                        copyFromView
                    ],
                    idMap: new Map([
                        [
                            copyFromView.id,
                            view_id
                        ]
                    ])
                });
                const sorts = await copyFromView.getSorts(context, ncMeta);
                const filters = await _Filter.default.rootFilterList(context, {
                    viewId: copyFromView.id
                }, ncMeta);
                const viewColumns = await copyFromView.getColumns(context, ncMeta);
                const sortInsertObjs = [];
                const filterInsertObjs = [];
                for (const sort of sorts){
                    const sortProps = (0, _extractProps.extractProps)(sort, [
                        'fk_column_id',
                        'fk_level_id',
                        'direction',
                        'base_id',
                        'source_id'
                    ]);
                    if (sortProps.fk_level_id) {
                        sortProps.fk_level_id = levelIdMap.get(sortProps.fk_level_id) || sortProps.fk_level_id;
                    }
                    sortInsertObjs.push(_extends({}, sortProps, {
                        fk_view_id: view_id,
                        id: undefined
                    }));
                    _Noco.default.appHooksService.emit(_nocodbsdk.AppEvents.SORT_CREATE, {
                        sort: _extends({}, sort, {
                            id: undefined
                        }),
                        view: view,
                        column: await _Column.default.get(context, {
                            colId: sort.fk_column_id
                        }),
                        req,
                        context
                    });
                }
                for (const filter of filters){
                    const fn = async (filter, parentId = null)=>{
                        const generatedId = await ncMeta.genNanoid(_globals.MetaTable.FILTER_EXP);
                        const filterProps = (0, _extractProps.extractProps)(filter, [
                            'fk_level_id',
                            'fk_parent_column_id',
                            'fk_row_color_condition_id',
                            'fk_column_id',
                            'comparison_op',
                            'comparison_sub_op',
                            'value',
                            'fk_parent_id',
                            'is_group',
                            'logical_op',
                            'base_id',
                            'source_id',
                            'order',
                            'meta'
                        ]);
                        if (filterProps.fk_level_id) {
                            filterProps.fk_level_id = levelIdMap.get(filterProps.fk_level_id) || filterProps.fk_level_id;
                        }
                        filterInsertObjs.push(_extends({}, filterProps, {
                            fk_view_id: view_id,
                            id: generatedId,
                            fk_parent_id: parentId
                        }));
                        if (filter.is_group) await Promise.all((await filter.getChildren(context) || []).map(async (child)=>{
                            await fn(child, generatedId);
                        }));
                        _Noco.default.appHooksService.emit(_nocodbsdk.AppEvents.FILTER_CREATE, {
                            filter: _extends({}, filter, {
                                id: undefined
                            }),
                            column: await _Column.default.get(context, {
                                colId: filter.fk_column_id
                            }),
                            view: view,
                            req,
                            context
                        });
                    };
                    await fn(filter);
                }
                await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.SORT, sortInsertObjs);
                await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, duplicateRowColorConditions.filters.concat(filterInsertObjs), true);
                await ncMeta.bulkMetaInsert(context.workspace_id, context.base_id, _globals.MetaTable.ROW_COLOR_CONDITIONS, duplicateRowColorConditions.rowColorConditions, true);
                // populate view columns
                await View.bulkColumnInsertToViews(context, {
                    viewColumns,
                    copyFromView
                }, insertedView);
            } else {
                // populate view columns
                await View.bulkColumnInsertToViews(context, {
                    columns: await model.getColumns(context, ncMeta)
                }, insertedView);
            }
            // Associate bulk-inserted list view columns with the default level
            if (view.type === _nocodbsdk.ViewTypes.LIST && defaultLevelId) {
                await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.LIST_VIEW_COLUMNS, {
                    fk_level_id: defaultLevelId
                }, {
                    fk_view_id: view_id
                });
            }
            if (copyFromView) {
                _Noco.default.appHooksService.emit(_nocodbsdk.AppEvents.VIEW_DUPLICATE_COMPLETE, {
                    sourceView: copyFromView,
                    destView: view,
                    req,
                    context
                });
            }
            return insertedView;
        } catch (e) {
            if (copyFromView) {
                _Noco.default.appHooksService.emit(_nocodbsdk.AppEvents.VIEW_DUPLICATE_FAIL, {
                    sourceView: copyFromView,
                    destView: view,
                    error: e,
                    req,
                    context
                });
                if (e instanceof _ncError.NcError || e instanceof _nocodbsdk.NcBaseError) throw e;
                logger.error('Failed to Duplicate View', e);
                _ncError.NcError.get(context).internalServerError('Failed to Duplicate View');
            }
            if (e instanceof _ncError.NcError || e instanceof _nocodbsdk.NcBaseError) throw e;
            logger.error('Failed to create View', e);
            _ncError.NcError.get(context).internalServerError('Failed to create View');
        }
    }
    static extractViewColumnsTableName(view) {
        let table;
        switch(view.type){
            case _nocodbsdk.ViewTypes.GRID:
                table = _globals.MetaTable.GRID_VIEW_COLUMNS;
                break;
            case _nocodbsdk.ViewTypes.GALLERY:
                table = _globals.MetaTable.GALLERY_VIEW_COLUMNS;
                break;
            case _nocodbsdk.ViewTypes.KANBAN:
                table = _globals.MetaTable.KANBAN_VIEW_COLUMNS;
                break;
            case _nocodbsdk.ViewTypes.FORM:
                table = _globals.MetaTable.FORM_VIEW_COLUMNS;
                break;
            case _nocodbsdk.ViewTypes.MAP:
                table = _globals.MetaTable.MAP_VIEW_COLUMNS;
                break;
            case _nocodbsdk.ViewTypes.LIST:
                table = _globals.MetaTable.LIST_VIEW_COLUMNS;
                break;
            case _nocodbsdk.ViewTypes.CALENDAR:
                table = _globals.MetaTable.CALENDAR_VIEW_COLUMNS;
                break;
        }
        return table;
    }
    static extractViewTableName(view) {
        let table;
        switch(view.type){
            case _nocodbsdk.ViewTypes.GRID:
                table = _globals.MetaTable.GRID_VIEW;
                break;
            case _nocodbsdk.ViewTypes.GALLERY:
                table = _globals.MetaTable.GALLERY_VIEW;
                break;
            case _nocodbsdk.ViewTypes.KANBAN:
                table = _globals.MetaTable.KANBAN_VIEW;
                break;
            case _nocodbsdk.ViewTypes.FORM:
                table = _globals.MetaTable.FORM_VIEW;
                break;
            case _nocodbsdk.ViewTypes.MAP:
                table = _globals.MetaTable.MAP_VIEW;
                break;
            case _nocodbsdk.ViewTypes.LIST:
                table = _globals.MetaTable.LIST_VIEW;
                break;
            case _nocodbsdk.ViewTypes.CALENDAR:
                table = _globals.MetaTable.CALENDAR_VIEW;
                break;
        }
        return table;
    }
    static extractViewColumnsTableNameScope(view) {
        let scope;
        switch(view.type){
            case _nocodbsdk.ViewTypes.GRID:
                scope = _globals.CacheScope.GRID_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.GALLERY:
                scope = _globals.CacheScope.GALLERY_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.MAP:
                scope = _globals.CacheScope.MAP_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.LIST:
                scope = _globals.CacheScope.LIST_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.KANBAN:
                scope = _globals.CacheScope.KANBAN_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.FORM:
                scope = _globals.CacheScope.FORM_VIEW_COLUMN;
                break;
            case _nocodbsdk.ViewTypes.CALENDAR:
                scope = _globals.CacheScope.CALENDAR_VIEW_COLUMN;
                break;
        }
        return scope;
    }
    static extractViewTableNameScope(view) {
        let scope;
        switch(view.type){
            case _nocodbsdk.ViewTypes.GRID:
                scope = _globals.CacheScope.GRID_VIEW;
                break;
            case _nocodbsdk.ViewTypes.GALLERY:
                scope = _globals.CacheScope.GALLERY_VIEW;
                break;
            case _nocodbsdk.ViewTypes.MAP:
                scope = _globals.CacheScope.MAP_VIEW;
                break;
            case _nocodbsdk.ViewTypes.LIST:
                scope = _globals.CacheScope.LIST_VIEW;
                break;
            case _nocodbsdk.ViewTypes.KANBAN:
                scope = _globals.CacheScope.KANBAN_VIEW;
                break;
            case _nocodbsdk.ViewTypes.FORM:
                scope = _globals.CacheScope.FORM_VIEW;
                break;
            case _nocodbsdk.ViewTypes.CALENDAR:
                scope = _globals.CacheScope.CALENDAR_VIEW;
                break;
        }
        return scope;
    }
    async getModel(context, ncMeta = _Noco.default.ncMeta) {
        return this.model = await _Model.default.getByIdOrName(context, {
            id: this.fk_model_id
        }, ncMeta);
    }
    async getModelWithInfo(context, ncMeta = _Noco.default.ncMeta) {
        return this.model = await _Model.default.getWithInfo(context, {
            id: this.fk_model_id
        }, ncMeta);
    }
    async getView(context, ncMeta = _Noco.default.ncMeta) {
        switch(this.type){
            case _nocodbsdk.ViewTypes.GRID:
                this.view = await _GridView.default.get(context, this.id, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.KANBAN:
                this.view = await _KanbanView.default.get(context, this.id, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.GALLERY:
                this.view = await _GalleryView.default.get(context, this.id, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.MAP:
                this.view = await _MapView.default.get(context, this.id, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.LIST:
                this.view = await _ListView.default.get(context, this.id, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.FORM:
                this.view = await _FormView.default.getWithInfo(context, this.id, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.CALENDAR:
                this.view = await _CalendarView.default.get(context, this.id, ncMeta);
                break;
        }
        return this.view;
    }
    async getViewWithInfo(context, ncMeta = _Noco.default.ncMeta) {
        switch(this.type){
            case _nocodbsdk.ViewTypes.GRID:
                this.view = await _GridView.default.getWithInfo(context, this.id, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.KANBAN:
                this.view = await _KanbanView.default.get(context, this.id, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.GALLERY:
                this.view = await _GalleryView.default.get(context, this.id, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.MAP:
                this.view = await _MapView.default.get(context, this.id, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.LIST:
                this.view = await _ListView.default.get(context, this.id, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.FORM:
                this.view = await _FormView.default.get(context, this.id, ncMeta);
                break;
            case _nocodbsdk.ViewTypes.CALENDAR:
                this.view = await _CalendarView.default.get(context, this.id, ncMeta);
                break;
        }
        return this.view;
    }
    async getFilters(context, ncMeta = _Noco.default.ncMeta) {
        return this.filter = await _Filter.default.getFilterObject(context, {
            viewId: this.id
        }, ncMeta);
    }
    async getSorts(context, ncMeta = _Noco.default.ncMeta) {
        return this.sorts = await _Sort.default.list(context, {
            viewId: this.id
        }, ncMeta);
    }
    async getColumns(context, ncMeta = _Noco.default.ncMeta) {
        return this.columns = await View.getColumns(context, this.id, ncMeta);
    }
    async delete(context, ncMeta = _Noco.default.ncMeta) {
        await View.delete(context, this.id, ncMeta);
    }
    static async updateIfColumnUsedAsExpandedMode(_context, _columnId, _modelId, _ncMeta = _Noco.default.ncMeta) {
        return;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
